<script>
import { getBottleInfo } from "@/api/flowPath"
import { Toast } from 'vant';
export default {
    methods: {
        mixScanCode(cb, type = 'qrCode'){
            console.log("发起扫码，等待回调")
            window.scanCodeCallBack = cb
            JS.open(type,"","scanCodeCallBack");//扫码
        },
        mixScanCamera(cb, v){
            console.log(v, "打开相机，等待回调")
            window.chooseCameraResult = cb
            JS.chooseCamera(v);//打开相机
        },
        mixChoosePhoto(cb, v){
            console.log(v, "打开相册，等待回调")
            window.choosePhotoResult = cb
            JS.choosePhoto(v);//打开相册
        },
        mixGetLocation(cb){
            window.locationCallBack = cb
            console.log('调用调用')
            JS.open("location","","locationCallBack");
        },
        async mixGetBottleInfo(bottle_id, type = 0){
            bottle_id = bottle_id || this.$store.state.bottleId
            const {code, msg, data} = await getBottleInfo({bottle_id}, type)
            code == 200 && this.$store.commit('setState',{name: type == 0 ? 'bottleInfo' : 'bottleInfoCache', value: data});
            console.log(data,"data")
            return {code, msg, data}
        },
        async mixfilterBottle(list){
            const proList = []
            list.map(bottle_id => proList.push(getBottleInfo({bottle_id}, 0)))
            const thenList = await Promise.all(proList)
            let tips = ""
            thenList.map((item, index) => {
                item.code != 200 && (tips += `${list[index]}：${item.msg}\n`)
            })
            console.log(thenList,"thenList")
            tips && Toast(tips)
            return thenList.filter((it, i) => {
                it.code == 200 && (it.data.ewm = list[i]);
                return it.code == 200
            }).map(it => it.data)
        },
        mixGetCache(key, v){
            const val = localStorage.getItem(key)
            if(val){
                return JSON.parse(val)
            }
            return v
        },
        mixSetCache(key,val){
            localStorage.setItem(key, JSON.stringify(val))
        },
        mixDecode(url){
            let bottleId = ''
            console.log(url, '>>>>>>>>>>>>>>>>>>>>>>>>>')
            // 东凤码
            if (url.indexOf("|") != -1) {
                bottleId = url.split('|')
                return bottleId[bottleId.length - 1]
            }
            if(url.indexOf("http") != 0){
                // 其他包含=的码
                if (url.indexOf('=') != -1){
                    bottleId = url.split('=')
                    return bottleId[bottleId.length - 1]
                }
                // 其他包含/的码
                if (url.indexOf('/') != -1){
                    bottleId = url.split('/')
                    return bottleId[bottleId.length - 1]
                }
                return url
            }
            // 东凤码
            // http://www.tl6.cc/4420/9700010884
            if (url.indexOf("www.tl6.cc") != -1) {
                bottleId = url.split("/");
                bottleId = bottleId[bottleId.length - 1]
                return bottleId
            }
            
            // 治安云
            // http://qr.gdzay.com/CylRecord?barCode=270320
            if (url.indexOf("qr.gdzay.com") != -1) {
                return url.split('?barCode=')[1]
            }
            // 云彩码
            // https://h5.yuncai-tech.com/#/search/bottleInfo?bottleId=DZ40090725
            if (url.indexOf("admin.yuncai-tech.com") != -1 || url.indexOf("tadmin.yuncai-tech.com") != -1 || url.indexOf("dist.yuncai-tech.com") != -1) {
                return url.split('?bottleId=')[1]
            }

            // 其他包含=的码
            if (url.indexOf('=') != -1){
                bottleId = url.split('=')
                return bottleId[bottleId.length - 1]
            }
            // 其他包含/的码
            if (url.indexOf('/') != -1){
                bottleId = url.split('/')
                return bottleId[bottleId.length - 1]
            }
            return url
        }
    }
}
</script>

<style>

</style>